import * as $Exception from "@reolink/web.exception-js";
const exceptionRegistry = $Exception.createExceptionRegistry({
  module: "reolink-web.utils",
  types: {
    "utils": {
      index: $Exception.createIncreaseCodeIndex(4294967296)
    }
  }
});
const E_INVALID_KEY = exceptionRegistry.register({
  name: "invalid_key",
  message: "Key is invalid",
  metadata: {},
  type: "utils"
});
const E_EXCEEDED_RETRYABLE_TIMES = exceptionRegistry.register({
  name: "exceeded_retryable_times",
  message: "Exceeded the maximum times of retry.",
  metadata: {},
  type: "utils"
});
const E_CASE_STYLE_NOT_SUPPORT = exceptionRegistry.register({
  name: "case_style_not_support",
  message: "The style of identity casing can not be handled.",
  metadata: {},
  type: "utils"
});
const E_INVALID_URL = exceptionRegistry.register({
  name: "invalid_url",
  message: "Failed to construct 'URL': Invalid URL",
  metadata: {},
  type: "utils"
});
const E_INVALID_TYPE = exceptionRegistry.register({
  name: "invalid_storage_type",
  message: "Storage type is invalid",
  metadata: {},
  type: "utils"
});
exceptionRegistry.register({
  name: "not_serializable",
  message: "The value is not a valid value for the JSON.stringify()",
  metadata: {},
  type: "utils"
});
const E_UPLOAD_KEY_NOT_FIND = exceptionRegistry.register({
  name: "upload_key_not_find",
  message: "The upload key is not exist. Please make sure that you already create task for your file.",
  metadata: {},
  type: "utils"
});
export {
  E_CASE_STYLE_NOT_SUPPORT,
  E_EXCEEDED_RETRYABLE_TIMES,
  E_INVALID_KEY,
  E_INVALID_TYPE,
  E_INVALID_URL,
  E_UPLOAD_KEY_NOT_FIND,
  exceptionRegistry
};
//# sourceMappingURL=index.js.map
